export interface GeneralDataModel {
  pageName: string;
  datas?: any;
  id: string; //单据id
  claimType: string; //单据类型
  taskStatus: string; //单据状态
  businessType: string; //业务分类
  ecKindId: string; //业务类型ID
  docKindId: string; //单据类型ID
  unitId: string; //公司ID
  curUserId?: any;
  actionCode: string; //判断按钮的状态
  allParams: string; //当前页所有字段
  opinions01?: any;
  opinions02?: any;
}

//分发到各个页面的数据
export class DataSourceModel {
  "baseInfo": any; //基本信息
  "detailList": any; //明细
  "invoiceList"?: any; //发票信息
  "paymentList"?: any; //支付信息
  "payoffList"?: any; //核销信息
  "ecAlcaDtlDtoList"?: any; //分摊明细
  "contractList"?: any; //合同信息
  "ecPublicPayDetainDtlList"?: any; //押款信息
  "ecPublicExpenseForDeductList"?: any; //扣款信息
  "feeList"?: any; //预算明细
  "detailTfList"?: any; //他方承担
  "detailSfTfList"?: any; //他方承担 盛丰
}

export const DataSourceKeyObj = {
  j: "baseInfo", //基本信息
  m: "detailList", //明细
  r: "reasonList", //出差计划明细
  f: "invoiceList", //发票信息
  z: "paymentList", //支付信息
  h: "payoffList", //核销信息
  ft: "ecAlcaDtlDtoList", //分摊明细
  ht: "contractList", //合同信息
  y: "ecPublicPayDetainDtlList", //押款信息
  k: "ecPublicExpenseForDeductList", //扣款信息
  bd: "feeList", //预算明细
  tf: "detailSfTfList", //他方承担
  tfsf: "detailSfTfList", //他方承担 盛丰
  jp: "detailTRTraffic", //机票 海信
  jd: "detailTRHotel", //酒店 海信
  zc: "detailTRRendcar", //租车 海信
  qt: "detailTROther", //其它 海信
};



// WEBPACK FOOTER //
// ./src/pages/common/general-detail/generalDetail.modal.ts